/**
 * StatCard — single coloured summary stat (CR-0015 / C-27).
 */
export default function StatCard({ bg, fg, value, label, testId }) {
  return (
    <div
      data-testid={testId}
      className="rounded-xl px-4 py-3 flex flex-col items-center justify-center min-w-[110px]"
      style={{ backgroundColor: bg }}
    >
      <div
        className="text-2xl font-bold leading-tight"
        style={{ color: fg }}
      >
        {value}
      </div>
      <div className="text-xs mt-1" style={{ color: "#6B7280" }}>
        {label}
      </div>
    </div>
  );
}
